<template>
  <div>
    <h1>403 Forbidden</h1>
    <p>{{ translation(4425) }}</p>
    <br/>
    Ga terug of login met een andere gebruiker
  </div>
</template>
<script>
import { FAMixin } from 'pevueglobal'

export default {      
  name: 'forbiddencomponent',
  mixins: [FAMixin],
  data: function () {
    return { }
  },
}
</script>
